<template>
  <b-row @click="goToJob" class="jobContainer">
    <div v-if="$store.state.miscData.DisplayImage" class="imgContainer">
      <b-img
        v-if="job.Image.length >= 1"
        thumbnail
        loading="lazy"
        fluid
        v-bind:src="job.Image"
        alt="Image 1"
        class="pb-1 pt-1 rounded jobImage"
      ></b-img>
      <b-img
        v-else
        thumbnail
        loading="lazy"
        fluid
        src="../../assets/placeholder-975x650.png"
        alt="Image 1"
        class="pb-1 pt-1 rounded jobImage"
      ></b-img>
    </div>
    <b-col>
      <div class="desktopSpecs">
        <div class="row1">
          <div class="column1 titleDiv">
            <span
              v-bind:class="
                $store.state.miscData.DisplayImage
                  ? 'titleWithImage'
                  : 'titleNoImage'
              "
              >{{ job.Name }}</span
            >
          </div>
        </div>
        <div class="row1 infoDiv">
          <div class="column1 specsDiv">
            <div id="descriptionDiv">
              <!-- <span v-html="getDescription">asdf</span> -->
              <span>{{ job.JobCardDescription.slice(0, 240) }}... </span>
              <span class="readMore" @click="goToJob">Lees meer</span>
            </div>
            <!-- <div id="lmao"></div> -->
            <div>
              <b-table-simple
                v-bind:class="{
                  withoutImageTable: !$store.state.miscData.DisplayImage,
                }"
                small
                fixed
                class="specTable"
              >
                <b-tbody>
                  <b-tr>
                    <b-td class="value">
                      <font-awesome-icon
                        class="plusMinus"
                        icon="graduation-cap"
                      />
                      {{ dashIfZeroOrEmpty(job.EducationLevel) }}
                    </b-td>
                    <b-td class="value">
                      <font-awesome-icon class="plusMinus" icon="clock" />
                      {{ dashIfZeroOrEmpty(job.ContractType) }}
                    </b-td>
                    <b-td class="value">
                      <font-awesome-icon class="plusMinus" icon="map-marker" />
                      {{ dashIfZeroOrEmpty(job.Place) }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
        </div>
      </div>
      <div class="mobileSpecs">
        <div class="row1 titleDiv">
          <span
            v-bind:class="
              $store.state.miscData.DisplayImage
                ? 'titleWithImage'
                : 'titleNoImage'
            "
            >{{ job.Name }}</span
          >
        </div>
        <div id="descriptionDiv">
          <!-- <span v-html="getDescription">asdf</span> -->
          <span v-if="job.JobCardDescription"
            >{{ job.JobCardDescription.slice(0, 120) }}...</span
          >
          <span class="readMore" @click="goToJob">Lees meer</span>
        </div>
        <b-table-simple
          v-bind:class="{
            withoutImageTable: !$store.state.miscData.DisplayImage,
          }"
          small
          fixed
          class="specTable"
        >
          <b-tbody>
            <b-tr>
              <b-td class="value">
                <font-awesome-icon class="plusMinus" icon="graduation-cap" />
                {{ dashIfZeroOrEmpty(job.EducationLevel) }}
              </b-td>
              <b-td class="value">
                <font-awesome-icon class="plusMinus" icon="clock" />
                {{ dashIfZeroOrEmpty(job.ContractType) }}
              </b-td>
              <b-td class="value">
                <font-awesome-icon class="plusMinus" icon="map-marker" />
                {{ dashIfZeroOrEmpty(job.Place) }}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "JobCard",
  props: {
    job: Object,
  },
  methods: {
    dashIfZeroOrEmpty(value) {
      if (value == 0 || value == "" || value == "01-01-0001") {
        return "-";
      } else {
        return value;
      }
    },

    goToJob() {
      window.location.href = this.job.Url.slice(0, -1) + window.location.search;
    },

    getResizedImage: function (image) {
      return (image += "?height=300&bgcolor=fff");
    },
  },
};
</script>

<style scoped>
/* shared */
.readMore {
  cursor: pointer;
  text-decoration: underline;
}
.readMore:hover {
  font-weight: 600;
}
.jobContainer {
  background: #ffffff;
  margin-bottom: 5px;
  padding: 5px 0px;
  border-radius: 0.25rem;
  cursor: pointer;
}
.jobContainer:hover {
  background-color: rgb(248, 248, 255);
}
.imgContainer {
  width: 200px;
  margin: 2px 0px;
  text-align: center;
  /* border-right: 4px solid black; */
}
.mobileSpecs {
  display: none;
}
.desktopSpecs {
  display: block;
}
.jobImage {
  max-height: 140px;
}
.title {
  color: #0645ad;
}
.title:hover {
  text-decoration: none;
}
.desktopSpecs {
  display: none;
}
.mobileSpecs {
  display: none;
}
/* > 992px*/
@media screen and (min-width: 992px) {
  .jobContainer {
    min-height: 150px;
  }
  .desktopSpecs {
    display: block;
  }
  .titleWithImage {
    overflow: hidden;
    font-weight: 500;
  }
  .titleNoImage {
    font-size: 20px;
    overflow: hidden;
    font-weight: 500;
  }
  .titleDiv {
    width: 100%;
  }
  .infoDiv {
    margin-top: 5px;
  }
  .table-sm th,
  .table-sm td {
    padding: 0.1rem;
    font-size: 13px;
  }
  .specTable {
    margin-bottom: 0px;
    position: absolute;
    bottom: 0;
    width: 94%;
  }

  .specTable th,
  .specTable td {
    padding: 0.1rem;
    font-size: 13px;
  }
  .withoutImageTable th,
  .withoutImageTable td {
    text-align: center;
  }
  .spec {
    width: 60%;
  }
  .value {
    width: 40%;
  }
  .tableHeader {
    font-weight: 700;
  }
  .noBorder {
    border: 0px solid black;
  }
  #descriptionDiv {
    font-size: 14px;
  }
}
/* =< 991 */
@media screen and (max-width: 991px) {
  .jobContainer {
    min-height: 165px;
  }
  .mobileSpecs {
    display: block;
    padding: 2px;
  }
  .titleDiv {
    font-size: 16px;
    overflow: hidden;
    font-weight: 500;
    width: 100%;
  }
  .table {
    position: absolute;
    bottom: 0;
    width: 94%;
    margin-bottom: 0px;
  }
  .table-sm th,
  .table-sm td {
    padding: 0.1rem;
    font-size: 13px;
  }
  .specTable {
    margin-bottom: 0px;
    position: absolute;
    bottom: 0;
    width: 94%;
  }

  .specTable th,
  .specTable td {
    padding: 0.1rem;
    font-size: 13px;
  }
  .withoutImageTable th,
  .withoutImageTable td {
    text-align: center;
  }
  .imgContainer {
    width: 120px;
    margin: auto auto auto 5px;
  }
  .jobContainer {
    padding: 0px 0px;
  }
  .jobImage {
    max-height: 90px;
  }
  #descriptionDiv {
    font-size: 14px;
    padding-bottom: 43px;
  }
}
</style>
